import { Observable } from 'rxjs';
import memoize from 'lodash.memoize';
import { asap } from 'rxjs/scheduler/asap';
import { WlWindow } from 'typings/globals/cordova';
import getScrollParent from 'utils/getScrollParent';

declare const window: WlWindow;

const orientationchange$ = Observable.fromEvent(window, 'orientationchange').share();

export const onResize$ = memoize((element: any = window): Observable<{}> =>
  Observable.merge(
    Observable.of('init'),
    Observable.fromEvent(document, 'ready'),
    Observable.fromEvent(document, 'deviceready'),
    Observable.fromEvent(element, 'resize'),
    Observable.fromEvent(window, 'resize'),
    orientationchange$,
    orientationchange$.delay(200), // iOS needs multiple attempts to resize
    orientationchange$.delay(500),
    asap
  )
    .auditTime(200)
    .do(e => console.debug('onResize', e))
    .shareReplay(1)
);

export function scrollToFocusedOnKeyboard() {
  const PADDING = 30;
  const subscription = Observable.fromEvent(window, 'keyboardDidShow')
    .subscribe(() => {
      const element = document.activeElement;
      const offset = parseInt(element.getAttribute('data-scrolloffset') || '0', 10);

      const elementRect = element.getBoundingClientRect();
      if (elementRect.bottom >= window.innerHeight - offset) {
        const parent = getScrollParent(element);
        parent
          .scrollBy({
            behavior: 'smooth',
            top: elementRect.bottom - window.innerHeight + offset + PADDING,
          });
      }
    });
  return () => subscription.unsubscribe();
}
